import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import "./styles.css";

// for anyone poking around in devtools
const brand =
  "color:#d97757;font-family:monospace;font-size:16px;font-weight:700;padding:4px 0";
const dim = "color:#6b7280;font-family:monospace;font-size:11px";
const green = "color:#4ade80;font-family:monospace;font-size:11px";
console.log("%cBrainSteam Labs", brand);
console.log("%c// found the backstage. nice.", green);
console.log(
  "%c// say hi → hello@brainsteam.cloud · open an issue on github/bigadamknight/brainsteam-labs",
  dim
);

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </StrictMode>
);
